import { Children } from "react"
import classNames from "classnames"

import { useDialogModal, DialogCommands } from "web/hooks/modals"
import TileControls from "./TileControls"

export default function Tile({
  title,
  children,
  handleTileSettings,
  handleEditMode,
  handleSave,
  isEditMode,
  handleOnHide,
  tileContentClasses,
  canEdit = true,
  breakoutLink,
}) {
  function handleBreakout() {
    window.Turbo.visit(breakoutLink)
  }

  const hasFooter = Children.count(children) === 2
  const confirmDeleteTile = useDialogModal({
    title: "Remove Tile",
    prompt: "Are you sure you want to remove this tile?",
    commands: [
      { label: "Remove", variant: "primary_danger", response: true },
      DialogCommands.Cancel,
    ],
  })

  async function handleDeleteTile() {
    const result = await confirmDeleteTile()

    if (result?.response) {
      handleOnHide()
    }
  }

  return (
    <div className="group relative flex h-full flex-col">
      <header
        className={classNames(
          "transition-text flex h-14 items-center rounded-t border-b border-neutral-9 bg-clip-padding px-4 font-bold text-neutral-3 duration-200 ease-in-out",
          { "text-md": isEditMode },
          { "text-lg": !isEditMode }
        )}
      >
        <p>{title}</p>
        {canEdit && (
          <TileControls
            handleTileSettings={handleTileSettings}
            handleEditMode={handleEditMode}
            handleSave={handleSave}
            isEditMode={isEditMode}
            handleOnHide={handleDeleteTile}
            handleBreakout={breakoutLink && handleBreakout}
          />
        )}
      </header>

      <div
        className={classNames(
          "flex-1 overflow-hidden px-4 pt-2",
          tileContentClasses
        )}
      >
        {hasFooter ? children[0] : children}
      </div>
      {hasFooter && (
        <footer className="absolute inset-x-0 bottom-0 grid grid-cols-[1fr_auto] items-end py-2.5 pl-4 pr-8 text-right text-sm text-neutral-8">
          {children[1]}
        </footer>
      )}
    </div>
  )
}
